import {DiAxiosHttpRequest} from '@di-shared/api/di/DiAxiosHttpRequest';
import {DiAxiosHttpRequestEu} from '@di-shared/api/di/DiAxiosHttpRequestEu';
import {DiAxiosHttpRequestNa} from '@di-shared/api/di/DiAxiosHttpRequestNa';
import {DiApi} from '@di-shared/api/di/__generated';
import {DiApiEu} from '@di-shared/api/di/__generated_eu';
import {DiApiNa} from '@di-shared/api/di/__generated_na';

export const diApi = new DiApi(
  {
    BASE: import.meta.env.VITE_DI_KR_API_URL,
  },
  DiAxiosHttpRequest
);
export const diApiEu = new DiApiEu(
  {
    BASE: import.meta.env.VITE_DI_EU_API_URL,
  },
  DiAxiosHttpRequestEu
);

export const diApiNa = new DiApiNa(
  {
    BASE: import.meta.env.VITE_DI_NA_API_URL,
  },
  DiAxiosHttpRequestNa
);
